import type { RouteType } from "~/lib/api";
import { cn } from "~/lib/utils";
import { PillSelector } from "~/components/ui/pill-selector";
import { RouteTypeIcon } from "~/components/ui/icons/route-type-icons";

const ROUTE_TYPES: { value: RouteType; label: string }[] = [
  { value: "loop", label: "Loop" },
  { value: "out-and-back", label: "Out & Back" },
  { value: "point-to-point", label: "Point to Point" },
];

interface RouteTypeSelectorProps {
  value: RouteType | null;
  onChange: (value: RouteType | null) => void;
  disabled?: boolean;
}

export function RouteTypeSelector({ value, onChange, disabled }: RouteTypeSelectorProps) {
  return (
    <PillSelector.Root value={value} onChange={onChange} label="Route type" disabled={disabled}>
      {ROUTE_TYPES.map(({ value: routeType, label }) => (
        <PillSelector.Option key={routeType} value={routeType}>
          <RouteTypeIcon routeType={routeType} className="size-3.5" />
          {label}
        </PillSelector.Option>
      ))}
    </PillSelector.Root>
  );
}

interface RouteTypeBadgeProps {
  routeType: RouteType;
  className?: string;
}

export function RouteTypeBadge({ routeType, className }: RouteTypeBadgeProps) {
  const config = ROUTE_TYPES.find((r) => r.value === routeType);
  if (!config) return null;

  return (
    <span className={cn("inline-flex items-center gap-1 text-sm", className)}>
      <RouteTypeIcon routeType={routeType} className="size-4" />
      {config.label}
    </span>
  );
}
